var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakePrimaryDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01333 11.5667C5.88667 11.5667 5.75333 11.5267 5.64667 11.4467C5.44 11.2933 5.35333 11.02 5.43333 10.7733L6.00667 8.93333L4.55333 7.75333C4.36 7.58667 4.28667 7.32 4.37333 7.08C4.46 6.84 4.69333 6.68 4.94667 6.68H6.78L7.42667 4.94C7.51333 4.7 7.74667 4.54 8 4.54C8.25333 4.54 8.48667 4.7 8.57333 4.94L9.22 6.68H11.0533C11.3067 6.68 11.54 6.84 11.6267 7.08C11.7133 7.32 11.64 7.59333 11.4467 7.76L10 8.94L10.6 10.76C10.68 11.0067 10.6 11.28 10.3933 11.4333C10.1867 11.5933 9.90667 11.6 9.68667 11.46L8.00667 10.3667L6.35333 11.4733C6.25333 11.54 6.13333 11.5733 6.01333 11.5733V11.5667ZM8 16C3.58667 16 0 12.4133 0 8C0 3.58667 3.58667 0 8 0C12.4133 0 16 3.58667 16 8C16 12.4133 12.4133 16 8 16ZM8 1.33333C4.32667 1.33333 1.33333 4.32667 1.33333 8C1.33333 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePrimaryDocumentIcon);
export default __webpack_public_path__ + "static/media/make-primary-document-icon.4cb51401f67053cee334e22026798bfd.svg";
export { ForwardRef as ReactComponent };